import { useAsyncValue, useNavigate, useSubmit } from 'react-router-dom';
import React, { useCallback, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';

// Components
import AddVehicleForm from '../../../../components/forms/AddVehicleForm';

// Utils
import { createFormDataFromValues } from '../../../../utils/forms';

// Constants
import { formVehicleNaming } from '../../../../components/forms/AddVehicleForm/constants';

// Styles
import { Container } from './styles';

// Types
import {
  type AddBasicInfoAccidentLoaderWithDynamicTypes,
  type AddBasicInfoAccidentWithDynamicKeys,
} from './types';
import { OrderType } from '../../../../types/orders';

// Redux
import { roidOTSelected } from '../../../../state/actions/ui/roidOTSelectedGeneralView';

// Offline
import { withNavigationFeedback } from '../../../../utils/navigationFeedback';

export default function AddVehiclePage(): JSX.Element {
  const navigate = useNavigate();
  const loaderData =
    useAsyncValue() as AddBasicInfoAccidentLoaderWithDynamicTypes;
  const dispatch = useDispatch();

  const submit = useSubmit();

  const handleReturn = useCallback(() => {
    navigate(-1);
  }, []);

  useLayoutEffect(() => {
    if (!loaderData) {
      // Sin alta de ESTE padre el loader devuelve `null` (Task 9): rebote al
      // paso 1 con `replace`, para que «atrás» no vuelva a caer aquí
      // (revisión de la Task 12a).
      navigate('..', { replace: true });
    } else {
      dispatch(
        roidOTSelected(
          OrderType.Accident,
          loaderData.orderParentRoid,
          loaderData.orderParentId
        )
      );
    }
  }, []);

  const onFormSubmit = (values: AddBasicInfoAccidentWithDynamicKeys) => withNavigationFeedback(async () => {
    // Sin red o con red degradada decide `saveData` (sondeo + plazo) y encola
    // él: un solo productor (spec 2026-09-08-fase2-encolada § 2 D10).
    // ── ONLINE: normal flow ──
    const formData = createFormDataFromValues({
      ...values,
      vehicles: JSON.stringify(values.vehicles),
    });

    submit(formData, {
      action: '.',
      method: 'POST',
    });
  });

  return (
    <Container>
      <AddVehicleForm
        onFormSubmit={onFormSubmit}
        namingPersistForm={formVehicleNaming.NEW_VEHICLE_FORM}
        onReturn={handleReturn}
        initialData={loaderData}
      />
    </Container>
  );
}
